import { INDEX_PULLERS_DRAGGERS, INDEX_PULLERS_DRAGGERS_STREAM, } from "../../../interface/iIndexPullersDraggers";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
    hideFlag: false,
};
const indexPullersDraggers = (state = initState, action) => {
    switch (action.type) {
        case INDEX_PULLERS_DRAGGERS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, hideFlag: action.payload.hideFlag });
        case INDEX_PULLERS_DRAGGERS_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default indexPullersDraggers;
